import React from "react";
import { toElementProps } from "../../Element.js";
import Block, { BlockStyles } from "../technical/Block.jsx";
import ECommerceCarousel, { ECommerceCarouselStyles } from "./ECommerceCarousel.jsx";

export function BlockECommerceSliderStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-slider": {
            display: "grid",
            gridGap: "20px",

            "& .slider-content": {
                justifyContent: "center",
                justifySelf: "center",
                maxWidth: "600px",

                [MobileBreakpoint]: {
                    padding: 0,
                    maxWidth: "400px",
                },
            },

            "& .big-slider": {
                margin: "20px",
            },

            "& .small-slider": {
                " & .thumbnail": {
                    overflow: "hidden",
                    transition: "border 0.3s ease-in-out",
                },

                "& .active-thumbnail": {
                    border: "1px solid rgba(0, 0, 0, 0.7)",
                },

                [MobileBreakpoint]: {
                    display: "none",
                },
            },

            "& .swiper-slide": {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "auto",

                "& img": {
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                },
            },
        },
        ...BlockStyles(params),
        ...ECommerceCarouselStyles(params),
    };
}

export default function BlockECommerceSlider(props) {
    const { PhotosNVideos } = props.variables;

    if (!PhotosNVideos) {
        return null;
    }

    if (!PhotosNVideos || PhotosNVideos?.length === 0) {
        return null;
    }

    const CNSlider = ["block-slider"];
    const elProps = toElementProps(props, { className: CNSlider });

    return (
        <Block>
            <div {...elProps}>
                <div className="slider-content">
                    <ECommerceCarousel items={PhotosNVideos} />
                </div>
            </div>
        </Block>
    );
}
